import { render, staticRenderFns } from "./RoleEditModal.vue?vue&type=template&id=28a69a86"
import script from "./RoleEditModal.vue?vue&type=script&lang=js"
export * from "./RoleEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports